import { Injectable } from '@angular/core';
import {HandleErrorService} from "../handleError.service";
import {environment} from "../../../environments/environment";
import {catchError} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PngoDealershipService  extends HandleErrorService {

  getDealershipInformations(dealershipId) {
    const apiSms = environment.pngoApi + 'api/backoffice/dealership-information-by-id/' + dealershipId;
    return this.http.get<any>(apiSms, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  updateDealershipInformations(body) {
    const apiSms = environment.pngoApi + 'api/backoffice/dealership-information/update';
    return this.http.put<any>(apiSms, body, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getDealerships() {
    const apiPngo = environment.pngoApi + 'api/backoffice/dealerships';
    return this.http.get<any>(apiPngo, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getSoftNetInformations(dealershipId) {
    const apiPngo = environment.pngoApi + 'api/backoffice/dealership-softnet-information/' + dealershipId;
    return this.http.get<any>(apiPngo, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
}
